import ConsumptionIntegral from './consumption_integral.vue';

export default ConsumptionIntegral;
